import React, { useState } from 'react';
import { ProcChartEntry } from "./ProcChartEntry";
import { RegenByRegenEntry } from "./RegenByRegenEntry";
import { RegenByHPEntry } from "./RegenByHP";

export function Chooser() {
    const [data, setData] = useState('');

    let page = null;

    switch(data) {
        case 'rr':
            page = (<RegenByRegenEntry />);
            break;
        case 'rhp':
            page = (<RegenByHPEntry />);
            break;
        default:
            page = (<ProcChartEntry />);
    }

    const mk_set = (val) => {
        return () => { setData(val); };
    }

    const is_active = (val) => val == data ? 'active' : '';

    return (
        <>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="navbar-nav">
            <a className={"nav-item nav-link " + is_active('')} href="#" onClick={mk_set('')}>Proc Damage</a>
            <a className={"nav-item nav-link " + is_active('rr')} href="#" onClick={mk_set('rr')}>Regen by regen</a>
            <a className={"nav-item nav-link " + is_active('rhp')} href="#" onClick={mk_set('rhp')}>Regen by max HP</a>
        </div>
        </nav>
        {page}
        </>
    );
}